import { render, staticRenderFns } from "./DetalheEsclarecimentoImpugnacaoTabela.vue?vue&type=template&id=8aeb5f16"
import script from "./DetalheEsclarecimentoImpugnacaoTabela.vue?vue&type=script&lang=js"
export * from "./DetalheEsclarecimentoImpugnacaoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports